import React from "react";
import type { ButtonProps } from "@shopify/polaris";
import { Button } from "@shopify/polaris";
import { addShopParamToUrl } from "../../helper_functions/utils";

export default function HorseButton({
  url,
  children,
  ...rest
}: ButtonProps): React.ReactElement {
  url = addShopParamToUrl(url);

  return <Button url={url} {...rest}>{children}</Button>;
}